<app-loader *ngIf="isLoaderOn"></app-loader>
<router-outlet></router-outlet>
